import { Button } from "@babackapp/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import useTranslation from "@babackapp/translations/use-translation";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { PropsWithChildren, useState } from "react";

interface DeleteApiKeyDialogProps extends PropsWithChildren {
  onConfirm: () => void;
}

export default function DeleteApiKeyDialog({
  children,
  onConfirm,
}: DeleteApiKeyDialogProps) {
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  const _handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>
            {t("settings.integrations.api.deleteKeyTitle")}
          </DialogTitle>
          <DialogDescription>
            <span className="font-medium px-2 py-1 text-xs gap-2 inline-flex items-center text-destructive">
              <ExclamationTriangleIcon className="size-4" />
              <span>
                {t("settings.integrations.api.deleteKeyConfirm")}
              </span>
            </span>
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center gap-4">
          <Button
            className="w-1/2"
            onClick={() => setOpen(false)}
            variant="outline"
          >
            {t("misc.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={_handleConfirm}
            type="button"
            className="w-1/2"
          >
            {t("settings.integrations.api.deleteKey")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
